import { status } from "skin/event/status";

const fn = (type, data) => {
  data.setValue("val", type === "promo" ? "промокод" : "бонусная система");
  return status.action;
};

export default function data(obj, form, story, data, d, action) {
  const type = data.s.values.fld["owner.type"];
  if (type && obj.action === "setEnd") fn(type, data);
  return status.action;
}
